import React from 'react';
import { List } from 'immutable';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ActivityDates = ({
  entity,
  activitySignUpRef,
  selectedDate,
  setSelectedDate,
  scrollFormIntoView = true,
}) => {
  const { t } = useTranslation();

  const title = entity.getIn(['title', 0, 'value'], '');

  const locationName = entity.getIn(['field_location', 0, 'entity', 'name', 0, 'value'], '');
  const locationAddress = entity.getIn(['field_location', 0, 'entity', 'field_address', 0], '');
  const dateRanges = entity.getIn(['field_date_ranges', 0, 'dates'], List());


  if ((!dateRanges.size > 0) || !locationName || !locationAddress) {
    return;
  }

  const onDateSelect = (dateIndex) => {
    if (scrollFormIntoView) {
      activitySignUpRef.current.scrollIntoView();
    }
    setSelectedDate(dateIndex);
  };

  return (
    <Container className="ActivityDates">
      <div className="row">
        <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <h2>{t('activity.date_title', { count: dateRanges.size, title })}</h2>
          <p className="subtitle">{t('activity.date_subtitle')}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          {dateRanges.map((date, i) => {
            const startDate = new Date(date.getIn(['start', 'date']));
            const endData = new Date(date.getIn(['end', 'date']));

            const formattedDate = format(startDate, 'eeee d MMMM');
            const formattedHour = format(startDate, 'HH:mm');
            const formattedEndHour = format(endData, 'HH:mm');

            return (
              <div
                key={i}
                className={`row ActivityDates__dates-wrapper ${selectedDate === i ? 'NodeActivityDetail__dates-wrapper--selected' : ''}`}
                onClick={() => onDateSelect(i)}
              >
                <div className="col-2 col-md-2 col-lg-1 lg-left">
                  <i className={`icon ${selectedDate === i ? 'icon-check-round' : 'icon-circle'} icon-variant-0`} />
                </div>
                <div className="col-10 col-md-6 col-lg-5">
                  <i className="icon icon-calendar icon-variant-0" />
                  <span className="date">{formattedDate[0].toUpperCase() + formattedDate.slice(1).toLowerCase()}
                  </span>
                </div>
                <div className="col-10 offset-2 offset-lg-0 col-md-5 col-lg-5 time">
                  <div>
                    <i className="icon icon-time icon-variant-0" />
                  </div>
                  <div>
                    {formattedHour}{t('activity.hour')}
                    {(endData && formattedHour !== formattedEndHour) && (
                      <>
                        <span> {t('general.until')}</span> {formattedEndHour}{t('activity.hour')}
                      </>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Container>
  );
};

export default ActivityDates;
